module.exports = {
    // apiUrl : 'http://localhost/client/builder/api/',
    apiUrl: 'https://generator.sumurdigital.com/api/',
    imgTypes : ['img', 'banner'],
    linkTypes : ['anchor', 'button'],
    innerHtmlTypes : ['paragraph']
}